// extracted by mini-css-extract-plugin
export default {"cls1":"wkwPiWuW9vPG_CUh6Ini","cls2":"rjSGt19w6kPMur1lbMkq wkwPiWuW9vPG_CUh6Ini"};